<template>
    <div class="modal-goodslist" :style="goodslist">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">老人添加</div>
            </div>
            <div class="modal-body" :style="bodyStyle">

                <el-form :model="addForm" :rules="elderlyAllType.rules" ref="addForm" label-position="top">
                    <div>
                        <el-row>
                            <el-card class="box-card">
                                <div slot="header" class="clearfix">
                                    <span>基本信息</span>
                                </div>
                                
                                <el-col :span="18">
                                    <el-col :span="8" class="item">
                                    <el-form-item label="姓名" required prop="name">
                                        <el-input v-model="addForm.name" placeholder="请输入姓名"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8" class="item">
                                    <el-form-item label="身份证号" required prop="idCard">
                                        <el-input v-model="addForm.idCard" maxlength="18" placeholder="请输入身份证号"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8" class="item">
                                    <el-form-item label="手机号">
                                        <el-input v-model="addForm.phone" maxlength="11" placeholder="请输入手机号"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8" class="item">
                                    <el-form-item label="婚姻状况"  prop="isMarriage">
                                        <el-select v-model="addForm.isMarriage" placeholder="请选择婚姻状况" style="width:100%">
                                            <el-option
                                                    v-for="item in elderlyAllType.maritalValue"
                                                    :key="item.value"
                                                    :label="item.label"
                                                    :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8" class="item">
                                    <el-form-item label="民族"  prop="sysNation" required>
                                        <el-select v-model="addForm.sysNation" filterable placeholder="请选择民族" style="width:100%">
                                            <el-option
                                                    v-for="item in nationValue"
                                                    :key="item.id"
                                                    :label="item.nation"
                                                    :value="item.id">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8" class="item">
                                    <el-form-item label="政治面貌" prop="politicsStatus">
                                        <el-select v-model="addForm.politicsStatus" placeholder="请选择政治面貌" style="width:100%">
                                            <el-option
                                                    v-for="item in elderlyAllType.politicalOutlook"
                                                    :key="item.value"
                                                    :label="item.label"
                                                    :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8" class="item">
                                    <el-form-item label="文化程度" prop="education">
                                        <el-select v-model="addForm.education" placeholder="请选择文化程度" style="width:100%">
                                            <el-option
                                                    v-for="item in elderlyAllType.education"
                                                    :key="item.value"
                                                    :label="item.label"
                                                    :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8" class="item">
                                    <el-form-item label="地区" required prop="areaCode">
                                        <el-cascader
                                            placeholder="请选择所属地区（可搜索）"
                                            v-model="addForm.areaCode"
                                            :options="areaValue"
                                            :props="props"
                                            ref="cascaderAddr"
                                            @change="handleAreaChange"
                                            filterable style="width:100%">
                                        </el-cascader>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8" class="item">
                                    <el-form-item label="详细地址" required prop="address" >
                                        <el-input v-model="addForm.address" placeholder="请选择详细地址" class="address"></el-input>
                                    </el-form-item>
                                </el-col>
                                </el-col>
                                <el-col :span="6" class="item">
                                    <el-form-item label="头像" required class="headImg">
                                        <el-upload
                                            ref="headImg"
                                            class="upload-demo"
                                            :action="uploadUrl"
                                            list-type="picture-card"
                                            :data='uploadData'
                                            :show-file-list="false"
                                            :on-success="handleImgSuccess"
                                            style="width:100%">
                                            <el-image v-if="addForm.headImg" :src="addForm.headImg" fit="cover" style="border-radius: 5px;" class="avatar"></el-image>
                                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                        </el-upload>
                                    </el-form-item>
                                </el-col>
                                
                            </el-card>
                            <el-card class="box-card">
                                <div slot="header" class="clearfix">
                                    <span>紧急联系人</span>
                                </div>
                                <el-col :span="6" class="item">
                                    <el-form-item label="联系人" required prop="urgencyContact">
                                        <el-input v-model="addForm.urgencyContact" placeholder="请输入联系人"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="6" class="item">
                                    <el-form-item label="紧急电话" required prop="urgencyPhone">
                                        <el-input v-model="addForm.urgencyPhone" maxlength="11" placeholder="请输入紧急电话"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="6" class="item">
                                    <el-form-item label="联系人1" >
                                        <el-input v-model="addForm.urgencyContact1" placeholder="请输入联系人"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="6" class="item">
                                    <el-form-item label="紧急电话1" >
                                        <el-input v-model="addForm.urgencyPhone1" maxlength="11" placeholder="请输入紧急电话"></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-card>
                            <el-image-viewer
                                            v-if="imgDialog"
                                            :on-close="imgClose"
                                            :url-list="srcList" />
                            <el-card class="box-card">
                                <div slot="header" class="clearfix">
                                    <span>证件上传</span>
                                    <!-- <el-form-item style="float:right;transform: translate(-20px, -10px);">
                                        <el-radio-group v-model="addForm.isWuBaoHu">
                                            <el-radio-button label="1">五保户</el-radio-button>
                                            <el-radio-button label="0">非五保户</el-radio-button>
                                        </el-radio-group>
                                    </el-form-item> -->
                                </div>
                                <el-row>
                                    <el-col :span="24" class="item">
                                        <el-form-item label="五保户" required>
                                            <el-radio-group v-model="addForm.isWuBaoHu">
                                                <el-radio :label="1">是</el-radio>
                                                <el-radio :label="0">否</el-radio>
                                            </el-radio-group>
                                        </el-form-item>
                                    </el-col>
                                <el-col :span="6" class="item">
                                    <el-form-item label="身份证正面">
                                        <el-upload
                                            class="upload-demo"
                                            :action="uploadUrl"
                                            list-type="picture-card"
                                            :data='uploadData'
                                            :show-file-list="false"
                                            :on-success="idCardFrontSuccess"
                                            style="width:100%">
                                            <el-image v-if="addForm.idCardFront" :src="addForm.idCardFront"  fit="cover" style="border-radius: 5px;" class="avatarImg"></el-image>
                                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                        </el-upload>
                                        
                                        <div class="uploadButton" v-if="addForm.idCardFront">
                                            <el-button type="primary" size="small" @click="imgPreview(addForm.idCardFront)">预览</el-button>
                                            <el-button type="success" size="small" @click="idCardFrontRemove">删除</el-button>
                                        </div>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="6" class="item">
                                    <el-form-item label="身份证反面">
                                        <el-upload
                                            class="upload-demo"
                                            :action="uploadUrl"
                                            list-type="picture-card"
                                            :data='uploadData'
                                            :show-file-list="false"
                                            :on-success="idCardContrarySuccess"
                                            style="width:100%">
                                            <el-image v-if="addForm.idCardContrary" :src="addForm.idCardContrary" fit="cover" style="border-radius: 5px;" class="avatarImg"></el-image>
                                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                        </el-upload>
                                        
                                        <div class="uploadButton" v-if="addForm.idCardContrary">
                                            <el-button type="primary" size="small" @click="imgPreview(addForm.idCardContrary)">预览</el-button>
                                            <el-button type="success" size="small" @click="idCardContraryRemove">删除</el-button>
                                        </div>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="6" class="item" v-if="addForm.isWuBaoHu==1">
                                    <el-form-item label="五保证首页" required prop="wuBaoHuImg1">
                                        <el-upload
                                            class="upload-demo"
                                            :action="uploadUrl"
                                            list-type="picture-card"
                                            :data='uploadData'
                                            :show-file-list="false"
                                            :on-success="wuBaoHuImg1Success"
                                            style="width:100%">
                                            <el-image v-if="addForm.wuBaoHuImg1" :src="addForm.wuBaoHuImg1"  fit="cover" style="border-radius: 5px;" class="avatarImg"></el-image>
                                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                        </el-upload>
                                        
                                        <div class="uploadButton" v-if="addForm.wuBaoHuImg1">
                                            <el-button type="primary" size="small" @click="imgPreview(addForm.wuBaoHuImg1)">预览</el-button>
                                            <el-button type="success" size="small" @click="wuBaoHuImg1Remove">删除</el-button>
                                        </div>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="6" class="item" v-if="addForm.isWuBaoHu==1">
                                    <el-form-item label="五保证自身所在页" required prop="wuBaoHuImg2">
                                        <el-upload
                                            class="upload-demo"
                                            :action="uploadUrl"
                                            list-type="picture-card"
                                            :data='uploadData'
                                            :show-file-list="false"
                                            :on-success="wuBaoHuImg2Success"
                                            style="width:100%">
                                            <el-image v-if="addForm.wuBaoHuImg2" :src="addForm.wuBaoHuImg2" fit="cover" style="border-radius: 5px;" class="avatarImg"></el-image>
                                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                        </el-upload>
                                        
                                        <div class="uploadButton" v-if="addForm.wuBaoHuImg2">
                                            <el-button type="primary" size="small" @click="imgPreview(addForm.wuBaoHuImg2)">预览</el-button>
                                            <el-button type="success" size="small" @click="wuBaoHuImg2Remove">删除</el-button>
                                        </div>
                                    </el-form-item>
                                </el-col>
                                </el-row>
                            </el-card>
                            <el-card class="box-card">
                                <div slot="header" class="clearfix">
                                    <span>健康状况</span>
                                </div>
                                <el-col :span="6" class="item">
                                    <el-form-item label="血型" prop="bloodType">
                                        <el-select v-model="addForm.bloodType" placeholder="请选择血型" style="width:100%">
                                            <el-option
                                                    v-for="item in elderlyAllType.bloodType"
                                                    :key="item.value"
                                                    :label="item.label"
                                                    :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="6" class="item">
                                    <el-form-item label="残疾情况" prop="disabilityStatus">
                                        <el-select v-model="addForm.disabilityStatus" placeholder="请选择残疾情况" style="width:100%">
                                            <el-option
                                                    v-for="item in elderlyAllType.disabilityType"
                                                    :key="item.value"
                                                    :label="item.label"
                                                    :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="6" class="item">
                                    <el-form-item label="过敏药物" prop="irritabilityMedicine">
                                        <el-input v-model="addForm.irritabilityMedicine" placeholder="请输入过敏药物"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="6" class="item">
                                    <el-form-item label="医疗保障情况" prop="medicalSecurityStatus">
                                        <el-select v-model="addForm.medicalSecurityStatus" placeholder="请选择医疗保障情况" style="width:100%">
                                            <el-option
                                                    v-for="item in elderlyAllType.medicalSecurity"
                                                    :key="item.value"
                                                    :label="item.label"
                                                    :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="6" class="item">
                                    <el-form-item label="主要疾病" prop="illness">
                                        <el-input v-model="addForm.illness" placeholder="请输入主要疾病"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="6" class="item">
                                    <el-form-item label="是否手术" prop="isOperation">
                                        <el-select v-model="addForm.isOperation" placeholder="请选择是否手术" style="width:100%">
                                            <el-option
                                                    v-for="item in elderlyAllType.status"
                                                    :key="item.value"
                                                    :label="item.label"
                                                    :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="6" class="item"  v-if="addForm.isOperation===1">
                                    <el-form-item label="手术原因" required prop="operationCause">
                                        <el-input v-model="addForm.operationCause" placeholder="请输入手术原因"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="6" class="item" v-if="addForm.isOperation===1">
                                    <el-form-item label="手术时间" required prop="operationTime">
                                        <el-date-picker
                                            v-model="addForm.operationTime"
                                            type="date"
                                            placeholder="请选择手术日期"
                                            :picker-options="pickerOptions0"
                                            style="width:100%">
                                        </el-date-picker>
                                    </el-form-item>
                                </el-col>
                            </el-card>
                            <el-card class="box-card">
                                <div slot="header" class="clearfix">
                                    <span>生活方式</span>
                                </div>
                                <el-col :span="6" class="item">
                                    <el-form-item label="饮食习惯"  prop="dietaryHabit">
                                        <el-select v-model="addForm.dietaryHabit" placeholder="请选择饮食习惯" style="width:100%">
                                            <el-option
                                                    v-for="item in elderlyAllType.dietHabits"
                                                    :key="item.value"
                                                    :label="item.label"
                                                    :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="6" class="item">
                                    <el-form-item label="忌食"  prop="diet">
                                        <el-input v-model="addForm.diet" placeholder="请输入忌食"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="6" class="item">
                                    <el-form-item label="吸烟状况" prop="smokeStatus">
                                        <el-select v-model="addForm.smokeStatus" placeholder="请选择吸烟状况" style="width:100%">
                                            <el-option
                                                    v-for="item in elderlyAllType.smokeType"
                                                    :key="item.value"
                                                    :label="item.label"
                                                    :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="6" class="item">
                                    <el-form-item label="饮酒频率" prop="drinkStatus">
                                        <el-select v-model="addForm.drinkStatus" placeholder="请选择饮酒频率" style="width:100%">
                                            <el-option
                                                    v-for="item in elderlyAllType.drinkType"
                                                    :key="item.value"
                                                    :label="item.label"
                                                    :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                            </el-card>
                            <el-card class="box-card">
                                <div slot="header" class="clearfix">
                                    <span>经济状况</span>
                                </div>
                                <el-col :span="6" class="item">
                                    <el-form-item label="经济来源"  prop="pocketbook">
                                        <el-select v-model="addForm.pocketbook" placeholder="请选择经济来源" style="width:100%">
                                            <el-option
                                                    v-for="item in elderlyAllType.economicSources"
                                                    :key="item.value"
                                                    :label="item.label"
                                                    :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                            </el-card>
                            <el-card class="box-card">
                                <div slot="header" class="clearfix">
                                    <span>亲属信息</span>
                                    <el-button style="float: right;transform: translate(-19px, -9px);" type="primary" @click="showForm">添加亲属</el-button>
                                </div>
                                <el-col :span="24" class="item">
                                    <el-table
                                        :data="relativesInfo"
                                        style="width: 100%" border>
                                        <el-table-column
                                            prop="name"
                                            label="亲属姓名">
                                        </el-table-column>
                                        <el-table-column
                                            prop="phone"
                                            label="联系电话">
                                        </el-table-column>
                                        <el-table-column
                                            prop="relation"
                                            :formatter="relations"
                                            label="与老人关系">
                                        </el-table-column>
                                        <el-table-column
                                            prop="workUnit"
                                            label="工作单位">
                                        </el-table-column>
                                        <el-table-column
                                            prop="address"
                                            label="地址">
                                        </el-table-column>
                                        <el-table-column fixed="right" label="操作" width="120">
                                            <template slot-scope="scope">
                                                <el-button type="primary" size="small" @click.native.prevent="deleteRow(scope.$index, relativesInfo)">删除</el-button>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </el-col>
                            </el-card>
                        </el-row>
                    </div>

                </el-form>
            </div>
            <div class="modal-footer">
                <el-button :loading="loading" type="primary" @click="confirm('addForm')">保存</el-button>
                <el-button type="success" @click="closeSelf">关闭</el-button>
            </div>
        </div>
        <RelativesAdd ref="relativesAdd" v-show="relativeShow" v-on:close="relativeShow=false"  v-on:relativeConfirm="relativeConfirm"></RelativesAdd>
    </div>
        
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";
    import RelativesAdd from "./RelativesAdd";
    import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
    import elderly from "@/common/status";
    import rules from "@/common/rules";
    const validatorIdNumber = (rule, value, callback) => {
        if (rules(value)) {
            callback();
        } else {
            return callback(new Error('请输入正确的证件号'))
        }
    };
    export default {
        name: 'Add',
        props: ['nationValue',"areaValue"],
        data() {
            return {
                srcList:[],
                loading: false,
                imgDialog: false,
                dialogIdCardValue: '',
                thsArea: '',
                uploadUrl:this.$institutionUrl+'Upload/Imgs',
                uploadData:{
                    staffCode:getStaffCode(),
                    timeStr:timeStr,
                    sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey)
                },
                relativeLoading: false,
                relativeShow:false,
                baiduMapShow:false,
                props: {
                    emitPath:false,
                    value: 'areaCode',
                    // 显示的文字字段名
                    label: 'name',
                    // 子层级字段名
                    children: 'listAreaDTO'
                },
                //时间范围限制
                pickerOptions0: {
                    disabledDate(time) {
                        return time.getTime() > Date.now() - 8.64e6
                    }
                },  
                pickerOptions1: {
                    disabledDate(time) {
                        return time.getTime() < Date.now() - 8.64e6
                    }
                },  
                relativesInfo:[],
                parentAreaCode:'00000000-0000-0000-0000-000000000000',
                addForm:{
                    timeStr:timeStr,
                    sign:null,
                    phone:null,
                    isMarriage:null,
                    dietaryHabit:null,
                    isOperation:null,
                    areaCode:null,
                    kinsfolk:null,
                    bloodType:null,
                    staffCode:getStaffCode(),
                    name:null,
                    idCard:null,
                    operationCause:'',
                    sysNation:null,
                    drinkStatus:null,
                    politicsStatus:null,
                    medicalSecurityStatus:null,
                    urgencyContact:null,
                    urgencyPhone:null,
                    urgencyContact1:null,
                    urgencyPhone1:null,
                    isWuBaoHu:0,
                    wuBaoHuImg1:null,
                    wuBaoHuImg2:null,
                    illness:'',
                    pocketbook:null,
                    diet:'',
                    disabilityStatus:null,
                    irritabilityMedicine:'',
                    education:null,
                    smokeStatus:null,
                    headImg:null,
                    address:null,
                    operationTime:'',
                    idCardFront:null,
                    idCardContrary:null,
                },
                bodyStyle:"height:"+(this.$store.state.tableHeight+50)+'px',
                goodslist:'',
                elderlyAllType:elderly,
            }
        },
       watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                console.log(val);
                this.bodyStyle = "height:"+(val+50)+'px';
            },
        },
       components:{
            RelativesAdd,ElImageViewer
        },
        methods: {
            init(){
                this.elderlyAllType.rules.idCard.push({ required: true,validator: validatorIdNumber, trigger: 'blur' })
                this.$refs.addForm.resetFields();
                this.addForm.headImg=null
                this.addForm.idCardFront=null
                this.addForm.idCardContrary=null
                this.loading = false
                var appNav=document.getElementsByClassName('app-nav');
                this.goodslist="left:"+appNav[0].scrollWidth+'px'
            },
            
            closeSelf() {
                this.$emit("closeAdd");
            },
            handleAreaChange(){
                var thsAreaCode = this.$refs.cascaderAddr.getCheckedNodes()
                this.thsArea=thsAreaCode[0].parent.label
            },
            openBaiduMap(){
                if(!this.addForm.areaCode){
                    this.$message({type: 'info', message: '请选择地区'});
                    return;
                }
                this.$refs.baiduMap.init(this.thsArea);
                this.baiduMapShow=true;
            },
            colseMap(){
                this.baiduMapShow=false
            },
            handleImgSuccess(res) {
                this.addForm.headImg = this.$imgUrl+res.data.path;
            },
            idCardFrontSuccess(res) {
                this.addForm.idCardFront =this.onSuccess(this.addForm.idCardFront,this.$imgUrl+res.data.path);
            },
            idCardContrarySuccess(res) {
                this.addForm.idCardContrary =this.onSuccess(this.addForm.idCardContrary,this.$imgUrl+res.data.path);
            },
            wuBaoHuImg1Success(res) {
                this.addForm.wuBaoHuImg1 =this.onSuccess(this.addForm.wuBaoHuImg1,this.$imgUrl+res.data.path);
            },
            wuBaoHuImg2Success(res) {
                this.addForm.wuBaoHuImg2 =this.onSuccess(this.addForm.wuBaoHuImg2,this.$imgUrl+res.data.path);
            },
            onSuccess(data,url){
                var index=this.srcList.indexOf(data)
                if(index!=-1){
                    this.srcList.splice(this.srcList.indexOf(data),1,url)
                }else{
                    this.srcList.push(url)
                }
                return url;
            },
            wuBaoHuImg1Remove() {this.addForm.wuBaoHuImg1 = '';},
            wuBaoHuImg2Remove() {this.addForm.wuBaoHuImg2 = '';},
            idCardFrontRemove() {this.addForm.idCardFront = '';},
            idCardContraryRemove() {this.addForm.idCardContrary = '';},
            imgPreview(url){
                this.srcList=this.getPreviewList(url)
            },
            imgClose() {this.imgDialog = false;},
            getPreviewList(url){
                this.imgDialog = true;
                var list=[]
                var list1=this.srcList;
                for(var i in list1){
                    if(list1[i]==url){
                        var str =list1.slice(i)
                        list=str.concat(list)
                        return list
                    }else{
                        list.push(list1[i])
                    }
                }
            },
            confirm(addForm){
                this.$refs[addForm].validate((valid) => {
                    if(valid){
                        this.addSubmit();
                    }else {
                        this.$message({type: 'warning', message: '请完善信息'});
                        return false;
                    }
                })

            },
            showForm(){
                this.relativeShow=!this.relativeShow;
            },
            relativeConfirm(relativeForm){
                this.relativesInfo.push(relativeForm);
                this.$refs.relativesEdit.init()
            },
            deleteRow(index, rows) {
                rows.splice(index, 1);
            },
            addSubmit(){

                if(this.addForm.headImg==null){
                    this.$message({type: 'info', message: '请上传头像'});
                    this.loading = false;
                    return;
                }
                
                var reg = /[^\u4E00-\u9FA5]/g;
                if(reg.test(this.addForm.urgencyContact)){
                    this.$message("紧急联系人请输入中文");
                    return;
                }
                this.loading = true;
                this.addForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);
                this.addForm.kinsfolk =JSON.stringify(this.relativesInfo);
                this.addForm.bloodType=this.isSelect(this.addForm.bloodType)
                this.addForm.disabilityStatus=this.isSelect(this.addForm.disabilityStatus)
                this.addForm.medicalSecurityStatus=this.isSelect(this.addForm.medicalSecurityStatus)
                this.addForm.isOperation=this.isSelect(this.addForm.isOperation)
                this.addForm.dietaryHabit=this.isSelect(this.addForm.dietaryHabit)
                this.addForm.smokeStatus=this.isSelect(this.addForm.smokeStatus)
                this.addForm.drinkStatus=this.isSelect(this.addForm.drinkStatus)
                this.addForm.pocketbook=this.isSelect(this.addForm.pocketbook)
                this.addForm.isMarriage=this.isSelect(this.addForm.isMarriage)
                this.addForm.politicsStatus=this.isSelect(this.addForm.politicsStatus)
                // this.addForm.nationId=this.isSelect(this.addForm.nationId)
                this.addForm.education=this.isSelect(this.addForm.education)
                this.addForm.censusRegister=this.isSelect(this.addForm.censusRegister)
                if(this.addForm.headImg!=null&&this.addForm.headImg!=''){
                    this.addForm.headImg=this.addForm.headImg.replace(this.$imgUrl,'')
                }
                if(this.addForm.idCardFront!=null&&this.addForm.idCardFront!=''){
                    this.addForm.idCardFront=this.addForm.idCardFront.replace(this.$imgUrl,'')
                }
                if(this.addForm.idCardContrary!=null&&this.addForm.idCardContrary!=''){
                    this.addForm.idCardContrary=this.addForm.idCardContrary.replace(this.$imgUrl,'')
                }
                if(this.addForm.wuBaoHuImg1!=null&&this.addForm.wuBaoHuImg1!=''){
                    this.addForm.wuBaoHuImg1=this.addForm.wuBaoHuImg1.replace(this.$imgUrl,'')
                }
                if(this.addForm.wuBaoHuImg2!=null&&this.addForm.wuBaoHuImg2!=''){
                    this.addForm.wuBaoHuImg2=this.addForm.wuBaoHuImg2.replace(this.$imgUrl,'')
                }
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"Elderly/Add",
                    data: this.addForm
                }).then(
                    (response) => {
                        this.loading = false;
                        if (response.data.error == 0) {
                            this.$emit("closeAdd");
                            this.$emit("getList");
                        }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                    }
                )
            },
            isSelect(data){
                if(data==null){
                    return 0
                }else{
                    return data
                }
            },
            relations(row){
                return this.allStatus(row.relation,elderly.relationship);
            },
            allStatus(row,status){
                for(var i in status){
                    if(status[i].value==row){
                        return status[i].label
                    }
                }
                return "其它";
            }


        }
    }


</script>



<style lang="scss" scoped>

    .modal-goodslist {
        position: fixed;
        top: 50px;
        right: 0;
        bottom: 0;
        left: 200px;
        background-color: rgba(0,0,0,.3);
        display: flex;
        // justify-content: center;
        // align-items: center;
        z-index: 99;

        .modal {
            background-color: #fff;
            box-shadow:  none;
            border-radius: 0;
            // overflow-x:auto;
            // display: flex;
            // flex-direction: column;
            // border-radius: 10px;
            width: 100%;

            .modal-header {
                border-bottom: 1px solid #eee;
                color: #313131;
                justify-content: space-between;
                padding: 10px;
                display: flex;
            }
            .add_title{
                margin-left: 20px;
                font-size: 16px;
            }
            .modal-body .avatar-uploader .el-upload {
                border: 1px dashed #d9d9d9;
                border-radius: 6px;
                cursor: pointer;
                position: relative;
                overflow: hidden;
            }
            .modal-body .avatar-uploader .el-upload:hover {
                border-color: #409EFF;
            }
            .modal-body .headImg .avatar-uploader-icon {
                font-size: 20px;
                color: #8c939d;
                width: 250px;
                height: 250px;
                line-height: 250px;
                text-align: center;
            }
            .modal-body .avatar-uploader-icon {
                font-size: 20px;
                color: #8c939d;
                width: 180px;
                height: 180px;
                line-height: 180px;
                text-align: center;
            }
            .modal-body .avatar-uploader-icon {
                font-size: 20px;
                color: #8c939d;
                width: 180px;
                height: 180px;
                line-height: 180px;
                text-align: center;
            }
            .modal-body .avatar {
                width: 250px;
                height: 250px;
                display: block;
            }
            .modal-body .headImg  /deep/ .el-upload--picture-card{
                width:250px;
                height: 250px;
                line-height: 250px;
            }
            .modal-body  /deep/ .el-upload--picture-card{
                width:100%;
                height: 180px;
                line-height: 180px;
            }
            .modal-body  .avatarImg{
                width:100%;
                height: 180px;
                line-height: 180px;
            }
            // .upload-demo{
            //     margin-top: 40px;
            // }
            .modal-body /deep/ .el-divider{
                margin: 10px 0px 0px;
            }
            .modal-body /deep/ .el-card.is-always-shadow{
                box-shadow:none;
                border-bottom: none;
                margin-bottom: 20px;
            }
            .address  /deep/ .el-input__inner{
                background: #fff;
            }
            .modal-body {
                position: relative;
                padding: 0px 0px 20px;
                z-index: 99;
                overflow-y:scroll;
                height:500px;
                /deep/ .el-image-viewer__close{
                    color: #fff;
                }
            }
            .modal-footer {
                border-top: 1px solid #eee;
                justify-content: center;
                padding: 15px;
                display: flex;
                .el-button{
                    width: 15%;
                }
            }
            .uploadButton{
                border-top: 1px solid #eee;
                justify-content: center;
                padding: 10px 0 0;
                display: flex;
                 .el-button{
                    width: 35%;
                }
            }


        }

    }


    .btn-close, .btn-confirm {
        border-radius: 8px;
        margin-left:16px;
        width:56px;
        height: 36px;
        border:none;
        cursor: pointer;
    }
    .btn-close {
        color: #313131;
        background-color:transparent;
    }



    .row{
        padding: 10px 0px;
    }
    .item{
        padding: 0px 20px;
    }
    .label{
        padding: 5px 0px;
    }


</style>
